import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import destr from 'destr';
import { n as normalizeBaseKey, a as normalizeKey, b as asyncCall, d as deserializeRaw, s as stringify, c as serializeRaw, j as joinKeys } from './shared/unstorage.8581f561.mjs';
export { p as prefixStorage } from './shared/unstorage.8581f561.mjs';
function defineDriver(factory) {
  return factory;
}
var DRIVER_NAME = "memory";
var memory = defineDriver(function () {
  var data = /* @__PURE__ */new Map();
  return {
    name: DRIVER_NAME,
    options: {},
    hasItem: function hasItem(key) {
      return data.has(key);
    },
    getItem: function getItem(key) {
      var _data$get;
      return (_data$get = data.get(key)) !== null && _data$get !== void 0 ? _data$get : null;
    },
    getItemRaw: function getItemRaw(key) {
      var _data$get2;
      return (_data$get2 = data.get(key)) !== null && _data$get2 !== void 0 ? _data$get2 : null;
    },
    setItem: function setItem(key, value) {
      data.set(key, value);
    },
    setItemRaw: function setItemRaw(key, value) {
      data.set(key, value);
    },
    removeItem: function removeItem(key) {
      data.delete(key);
    },
    getKeys: function getKeys() {
      return Array.from(data.keys());
    },
    clear: function clear() {
      data.clear();
    },
    dispose: function dispose() {
      data.clear();
    }
  };
});
function createStorage() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = {
    mounts: {
      "": options.driver || memory()
    },
    mountpoints: [""],
    watching: false,
    watchListeners: [],
    unwatch: {}
  };
  var _getMount8 = function getMount(key) {
    var _iterator = _createForOfIteratorHelper(context.mountpoints),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var base = _step.value;
        if (key.startsWith(base)) {
          return {
            base: base,
            relativeKey: key.slice(base.length),
            driver: context.mounts[base]
          };
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return {
      base: "",
      relativeKey: key,
      driver: context.mounts[""]
    };
  };
  var _getMounts = function getMounts(base, includeParent) {
    return context.mountpoints.filter(function (mountpoint) {
      return mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint);
    }).map(function (mountpoint) {
      return {
        relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
        mountpoint: mountpoint,
        driver: context.mounts[mountpoint]
      };
    });
  };
  var onChange = function onChange(event, key) {
    if (!context.watching) {
      return;
    }
    key = normalizeKey(key);
    var _iterator2 = _createForOfIteratorHelper(context.watchListeners),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var listener = _step2.value;
        listener(event, key);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  var startWatch = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var mountpoint;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!context.watching) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            context.watching = true;
            _context.t0 = _regeneratorRuntime.keys(context.mounts);
          case 4:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 11;
              break;
            }
            mountpoint = _context.t1.value;
            _context.next = 8;
            return watch(context.mounts[mountpoint], onChange, mountpoint);
          case 8:
            context.unwatch[mountpoint] = _context.sent;
            _context.next = 4;
            break;
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function startWatch() {
      return _ref.apply(this, arguments);
    };
  }();
  var stopWatch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var mountpoint;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (context.watching) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.t0 = _regeneratorRuntime.keys(context.unwatch);
          case 3:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 9;
              break;
            }
            mountpoint = _context2.t1.value;
            _context2.next = 7;
            return context.unwatch[mountpoint]();
          case 7:
            _context2.next = 3;
            break;
          case 9:
            context.unwatch = {};
            context.watching = false;
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function stopWatch() {
      return _ref2.apply(this, arguments);
    };
  }();
  var runBatch = function runBatch(items, commonOptions, cb) {
    var batches = /* @__PURE__ */new Map();
    var getBatch = function getBatch(mount) {
      var batch = batches.get(mount.base);
      if (!batch) {
        batch = {
          driver: mount.driver,
          base: mount.base,
          items: []
        };
        batches.set(mount.base, batch);
      }
      return batch;
    };
    var _iterator3 = _createForOfIteratorHelper(items),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var item = _step3.value;
        var isStringItem = typeof item === "string";
        var key = normalizeKey(isStringItem ? item : item.key);
        var value = isStringItem ? void 0 : item.value;
        var options2 = isStringItem || !item.options ? commonOptions : _objectSpread(_objectSpread({}, commonOptions), item.options);
        var mount = _getMount8(key);
        getBatch(mount).items.push({
          key: key,
          value: value,
          relativeKey: mount.relativeKey,
          options: options2
        });
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return Promise.all(_toConsumableArray(batches.values()).map(function (batch) {
      return cb(batch);
    })).then(function (r) {
      return r.flat();
    });
  };
  var storage = {
    // Item
    hasItem: function hasItem(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      key = normalizeKey(key);
      var _getMount = _getMount8(key),
        relativeKey = _getMount.relativeKey,
        driver = _getMount.driver;
      return asyncCall(driver.hasItem, relativeKey, opts);
    },
    getItem: function getItem(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      key = normalizeKey(key);
      var _getMount2 = _getMount8(key),
        relativeKey = _getMount2.relativeKey,
        driver = _getMount2.driver;
      return asyncCall(driver.getItem, relativeKey, opts).then(function (value) {
        return destr(value);
      });
    },
    getItems: function getItems(items, commonOptions) {
      return runBatch(items, commonOptions, function (batch) {
        if (batch.driver.getItems) {
          return asyncCall(batch.driver.getItems, batch.items.map(function (item) {
            return {
              key: item.relativeKey,
              options: item.options
            };
          }), commonOptions).then(function (r) {
            return r.map(function (item) {
              return {
                key: joinKeys(batch.base, item.key),
                value: destr(item.value)
              };
            });
          });
        }
        return Promise.all(batch.items.map(function (item) {
          return asyncCall(batch.driver.getItem, item.relativeKey, item.options).then(function (value) {
            return {
              key: item.key,
              value: destr(value)
            };
          });
        }));
      });
    },
    getItemRaw: function getItemRaw(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      key = normalizeKey(key);
      var _getMount3 = _getMount8(key),
        relativeKey = _getMount3.relativeKey,
        driver = _getMount3.driver;
      if (driver.getItemRaw) {
        return asyncCall(driver.getItemRaw, relativeKey, opts);
      }
      return asyncCall(driver.getItem, relativeKey, opts).then(function (value) {
        return deserializeRaw(value);
      });
    },
    setItem: function setItem(key, value) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var opts, _getMount4, relativeKey, driver;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              opts = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
              if (!(value === void 0)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return", storage.removeItem(key));
            case 3:
              key = normalizeKey(key);
              _getMount4 = _getMount8(key), relativeKey = _getMount4.relativeKey, driver = _getMount4.driver;
              if (driver.setItem) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return");
            case 7:
              _context3.next = 9;
              return asyncCall(driver.setItem, relativeKey, stringify(value), opts);
            case 9:
              if (!driver.watch) {
                onChange("update", key);
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    setItems: function setItems(items, commonOptions) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return runBatch(items, commonOptions, /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(batch) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!batch.driver.setItems) {
                          _context4.next = 2;
                          break;
                        }
                        return _context4.abrupt("return", asyncCall(batch.driver.setItems, batch.items.map(function (item) {
                          return {
                            key: item.relativeKey,
                            value: stringify(item.value),
                            options: item.options
                          };
                        }), commonOptions));
                      case 2:
                        if (batch.driver.setItem) {
                          _context4.next = 4;
                          break;
                        }
                        return _context4.abrupt("return");
                      case 4:
                        _context4.next = 6;
                        return Promise.all(batch.items.map(function (item) {
                          return asyncCall(batch.driver.setItem, item.relativeKey, stringify(item.value), item.options);
                        }));
                      case 6:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    setItemRaw: function setItemRaw(key, value) {
      var _arguments2 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var opts, _getMount5, relativeKey, driver;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              opts = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : {};
              if (!(value === void 0)) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return", storage.removeItem(key, opts));
            case 3:
              key = normalizeKey(key);
              _getMount5 = _getMount8(key), relativeKey = _getMount5.relativeKey, driver = _getMount5.driver;
              if (!driver.setItemRaw) {
                _context6.next = 10;
                break;
              }
              _context6.next = 8;
              return asyncCall(driver.setItemRaw, relativeKey, value, opts);
            case 8:
              _context6.next = 16;
              break;
            case 10:
              if (!driver.setItem) {
                _context6.next = 15;
                break;
              }
              _context6.next = 13;
              return asyncCall(driver.setItem, relativeKey, serializeRaw(value), opts);
            case 13:
              _context6.next = 16;
              break;
            case 15:
              return _context6.abrupt("return");
            case 16:
              if (!driver.watch) {
                onChange("update", key);
              }
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    removeItem: function removeItem(key) {
      var _arguments3 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var opts, _getMount6, relativeKey, driver;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              opts = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {};
              if (typeof opts === "boolean") {
                opts = {
                  removeMeta: opts
                };
              }
              key = normalizeKey(key);
              _getMount6 = _getMount8(key), relativeKey = _getMount6.relativeKey, driver = _getMount6.driver;
              if (driver.removeItem) {
                _context7.next = 6;
                break;
              }
              return _context7.abrupt("return");
            case 6:
              _context7.next = 8;
              return asyncCall(driver.removeItem, relativeKey, opts);
            case 8:
              if (!(opts.removeMeta || opts.removeMata)) {
                _context7.next = 11;
                break;
              }
              _context7.next = 11;
              return asyncCall(driver.removeItem, relativeKey + "$", opts);
            case 11:
              if (!driver.watch) {
                onChange("remove", key);
              }
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // Meta
    getMeta: function getMeta(key) {
      var _arguments4 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var opts, _getMount7, relativeKey, driver, meta, value;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              opts = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {};
              if (typeof opts === "boolean") {
                opts = {
                  nativeOnly: opts
                };
              }
              key = normalizeKey(key);
              _getMount7 = _getMount8(key), relativeKey = _getMount7.relativeKey, driver = _getMount7.driver;
              meta = /* @__PURE__ */Object.create(null);
              if (!driver.getMeta) {
                _context8.next = 12;
                break;
              }
              _context8.t0 = Object;
              _context8.t1 = meta;
              _context8.next = 10;
              return asyncCall(driver.getMeta, relativeKey, opts);
            case 10:
              _context8.t2 = _context8.sent;
              _context8.t0.assign.call(_context8.t0, _context8.t1, _context8.t2);
            case 12:
              if (opts.nativeOnly) {
                _context8.next = 17;
                break;
              }
              _context8.next = 15;
              return asyncCall(driver.getItem, relativeKey + "$", opts).then(function (value_) {
                return destr(value_);
              });
            case 15:
              value = _context8.sent;
              if (value && typeof value === "object") {
                if (typeof value.atime === "string") {
                  value.atime = new Date(value.atime);
                }
                if (typeof value.mtime === "string") {
                  value.mtime = new Date(value.mtime);
                }
                Object.assign(meta, value);
              }
            case 17:
              return _context8.abrupt("return", meta);
            case 18:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    setMeta: function setMeta(key, value) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.setItem(key + "$", value, opts);
    },
    removeMeta: function removeMeta(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.removeItem(key + "$", opts);
    },
    // Keys
    getKeys: function getKeys(base) {
      var _arguments5 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var opts, mounts, maskedMounts, allKeys, _iterator4, _step4, _loop;
        return _regeneratorRuntime.wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              opts = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : {};
              base = normalizeBaseKey(base);
              mounts = _getMounts(base, true);
              maskedMounts = [];
              allKeys = [];
              _iterator4 = _createForOfIteratorHelper(mounts);
              _context10.prev = 6;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var mount, rawKeys, keys;
                return _regeneratorRuntime.wrap(function _loop$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      mount = _step4.value;
                      _context9.next = 3;
                      return asyncCall(mount.driver.getKeys, mount.relativeBase, opts);
                    case 3:
                      rawKeys = _context9.sent;
                      keys = rawKeys.map(function (key) {
                        return mount.mountpoint + normalizeKey(key);
                      }).filter(function (key) {
                        return !maskedMounts.some(function (p) {
                          return key.startsWith(p);
                        });
                      });
                      allKeys.push.apply(allKeys, _toConsumableArray(keys));
                      maskedMounts = [mount.mountpoint].concat(_toConsumableArray(maskedMounts.filter(function (p) {
                        return !p.startsWith(mount.mountpoint);
                      })));
                    case 7:
                    case "end":
                      return _context9.stop();
                  }
                }, _loop);
              });
              _iterator4.s();
            case 9:
              if ((_step4 = _iterator4.n()).done) {
                _context10.next = 13;
                break;
              }
              return _context10.delegateYield(_loop(), "t0", 11);
            case 11:
              _context10.next = 9;
              break;
            case 13:
              _context10.next = 18;
              break;
            case 15:
              _context10.prev = 15;
              _context10.t1 = _context10["catch"](6);
              _iterator4.e(_context10.t1);
            case 18:
              _context10.prev = 18;
              _iterator4.f();
              return _context10.finish(18);
            case 21:
              return _context10.abrupt("return", base ? allKeys.filter(function (key) {
                return key.startsWith(base) && !key.endsWith("$");
              }) : allKeys.filter(function (key) {
                return !key.endsWith("$");
              }));
            case 22:
            case "end":
              return _context10.stop();
          }
        }, _callee9, null, [[6, 15, 18, 21]]);
      }))();
    },
    // Utils
    clear: function clear(base) {
      var _arguments6 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var opts;
        return _regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              opts = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : {};
              base = normalizeBaseKey(base);
              _context12.next = 4;
              return Promise.all(_getMounts(base, false).map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(m) {
                  var keys;
                  return _regeneratorRuntime.wrap(function _callee10$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        if (!m.driver.clear) {
                          _context11.next = 2;
                          break;
                        }
                        return _context11.abrupt("return", asyncCall(m.driver.clear, m.relativeBase, opts));
                      case 2:
                        if (!m.driver.removeItem) {
                          _context11.next = 7;
                          break;
                        }
                        _context11.next = 5;
                        return m.driver.getKeys(m.relativeBase || "", opts);
                      case 5:
                        keys = _context11.sent;
                        return _context11.abrupt("return", Promise.all(keys.map(function (key) {
                          return m.driver.removeItem(key, opts);
                        })));
                      case 7:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee10);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee11);
      }))();
    },
    dispose: function dispose() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return Promise.all(Object.values(context.mounts).map(function (driver) {
                return _dispose2(driver);
              }));
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee12);
      }))();
    },
    watch: function watch(callback) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return startWatch();
            case 2:
              context.watchListeners.push(callback);
              return _context15.abrupt("return", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                return _regeneratorRuntime.wrap(function _callee13$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      context.watchListeners = context.watchListeners.filter(function (listener) {
                        return listener !== callback;
                      });
                      if (!(context.watchListeners.length === 0)) {
                        _context14.next = 4;
                        break;
                      }
                      _context14.next = 4;
                      return stopWatch();
                    case 4:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee13);
              })));
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee14);
      }))();
    },
    unwatch: function unwatch() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              context.watchListeners = [];
              _context16.next = 3;
              return stopWatch();
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee15);
      }))();
    },
    // Mount
    mount: function mount(base, driver) {
      base = normalizeBaseKey(base);
      if (base && context.mounts[base]) {
        throw new Error("already mounted at ".concat(base));
      }
      if (base) {
        context.mountpoints.push(base);
        context.mountpoints.sort(function (a, b) {
          return b.length - a.length;
        });
      }
      context.mounts[base] = driver;
      if (context.watching) {
        Promise.resolve(watch(driver, onChange, base)).then(function (unwatcher) {
          context.unwatch[base] = unwatcher;
        }).catch(console.error);
      }
      return storage;
    },
    unmount: function unmount(base) {
      var _arguments7 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var _dispose;
        return _regeneratorRuntime.wrap(function _callee16$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _dispose = _arguments7.length > 1 && _arguments7[1] !== undefined ? _arguments7[1] : true;
              base = normalizeBaseKey(base);
              if (!(!base || !context.mounts[base])) {
                _context17.next = 4;
                break;
              }
              return _context17.abrupt("return");
            case 4:
              if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
              }
              if (!_dispose) {
                _context17.next = 8;
                break;
              }
              _context17.next = 8;
              return _dispose2(context.mounts[base]);
            case 8:
              context.mountpoints = context.mountpoints.filter(function (key) {
                return key !== base;
              });
              delete context.mounts[base];
            case 10:
            case "end":
              return _context17.stop();
          }
        }, _callee16);
      }))();
    },
    getMount: function getMount() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      key = normalizeKey(key) + ":";
      var m = _getMount8(key);
      return {
        driver: m.driver,
        base: m.base
      };
    },
    getMounts: function getMounts() {
      var base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      base = normalizeKey(base);
      var mounts = _getMounts(base, opts.parents);
      return mounts.map(function (m) {
        return {
          driver: m.driver,
          base: m.mountpoint
        };
      });
    }
  };
  return storage;
}
function snapshot(_x3, _x4) {
  return _snapshot.apply(this, arguments);
}
function _snapshot() {
  _snapshot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(storage, base) {
    var keys, snapshot2;
    return _regeneratorRuntime.wrap(function _callee18$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          base = normalizeBaseKey(base);
          _context19.next = 3;
          return storage.getKeys(base);
        case 3:
          keys = _context19.sent;
          snapshot2 = {};
          _context19.next = 7;
          return Promise.all(keys.map( /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(key) {
              return _regeneratorRuntime.wrap(function _callee17$(_context18) {
                while (1) switch (_context18.prev = _context18.next) {
                  case 0:
                    _context18.next = 2;
                    return storage.getItem(key);
                  case 2:
                    snapshot2[key.slice(base.length)] = _context18.sent;
                  case 3:
                  case "end":
                    return _context18.stop();
                }
              }, _callee17);
            }));
            return function (_x8) {
              return _ref6.apply(this, arguments);
            };
          }()));
        case 7:
          return _context19.abrupt("return", snapshot2);
        case 8:
        case "end":
          return _context19.stop();
      }
    }, _callee18);
  }));
  return _snapshot.apply(this, arguments);
}
function restoreSnapshot(_x5, _x6) {
  return _restoreSnapshot.apply(this, arguments);
}
function _restoreSnapshot() {
  _restoreSnapshot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(driver, snapshot2) {
    var base,
      _args20 = arguments;
    return _regeneratorRuntime.wrap(function _callee19$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          base = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : "";
          base = normalizeBaseKey(base);
          _context20.next = 4;
          return Promise.all(Object.entries(snapshot2).map(function (e) {
            return driver.setItem(base + e[0], e[1]);
          }));
        case 4:
        case "end":
          return _context20.stop();
      }
    }, _callee19);
  }));
  return _restoreSnapshot.apply(this, arguments);
}
function watch(driver, onChange, base) {
  return driver.watch ? driver.watch(function (event, key) {
    return onChange(event, base + key);
  }) : function () {};
}
function _dispose2(_x7) {
  return _dispose3.apply(this, arguments);
}
function _dispose3() {
  _dispose3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(driver) {
    return _regeneratorRuntime.wrap(function _callee20$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          if (!(typeof driver.dispose === "function")) {
            _context21.next = 3;
            break;
          }
          _context21.next = 3;
          return asyncCall(driver.dispose);
        case 3:
        case "end":
          return _context21.stop();
      }
    }, _callee20);
  }));
  return _dispose3.apply(this, arguments);
}
var builtinDrivers = {
  azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
  azureCosmos: "unstorage/drivers/azure-cosmos",
  azureKeyVault: "unstorage/drivers/azure-key-vault",
  azureStorageBlob: "unstorage/drivers/azure-storage-blob",
  azureStorageTable: "unstorage/drivers/azure-storage-table",
  cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
  cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
  cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
  fs: "unstorage/drivers/fs",
  fsLite: "unstorage/drivers/fs-lite",
  github: "unstorage/drivers/github",
  http: "unstorage/drivers/http",
  indexedb: "unstorage/drivers/indexedb",
  localStorage: "unstorage/drivers/localstorage",
  lruCache: "unstorage/drivers/lru-cache",
  memory: "unstorage/drivers/memory",
  mongodb: "unstorage/drivers/mongodb",
  netlifyBlobs: "unstorage/drivers/netlify-blobs",
  overlay: "unstorage/drivers/overlay",
  planetscale: "unstorage/drivers/planetscale",
  redis: "unstorage/drivers/redis",
  sessionStorage: "unstorage/drivers/session-storage",
  vercelKV: "unstorage/drivers/vercel-kv",
  /** @deprecated */
  "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
  /** @deprecated */
  "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};
export { builtinDrivers, createStorage, defineDriver, joinKeys, normalizeBaseKey, normalizeKey, restoreSnapshot, snapshot };